const gender = [
    { label: 'Male', value: 'Male' },
    { label: 'Female', value: 'Female' },
    { label: 'Others', value: 'Others' },
];

const maritalStatus = [
    { label: 'Single', value: 'single' },
    { label: 'Married', value: 'Married' },
    { label: 'Widow', value: 'Widow' },
]   
const employmentType = [
    { label: 'House Wife', value: 'House Wife' },
    { label: 'Salaried', value: 'Salaried' },
    { label: 'Self-Employed', value: 'Self Employed' },
    { label: 'Student', value: 'Student' },
    { label: 'Pensioner', value: 'Pensioner' }
]
const monthsArray = [
    { label: '0', value: 0 },
    { label: '1', value: 1 },
    {label: '2', value: 2 },
    {label: '3', value: 3 },
    {label: '4', value: 4 },
    {label: '5', value: 5 },
    {label: '6', value: 6 },
    {label: '7', value: 7 },
    {label: '8', value: 8 },
    {label: '9', value: 9 },    
    {label: '10', value: 10 },
    {label: '11', value: 11 },
]
const titleList = [

    { label: "Mr.", value: "Mr" },
  
    { label: "Ms.", value: "Ms" },
  
    { label: "Jr.", value: "Jr" },
  
    { label: "Mrs.", value: "Mrs" },
  
    { label: "Dr.", value: "Dr" },
  
  ];
   const AccountTypeData = [
    {
      value: "Savings Account",
      id: 1
    },
    {
      value: "Current Account",
      id: 2
    },
  ]
   const BankNamesData = [
    {
      value: "State Bank of India",
      id: 1
    },
    {
      value: "HDFC Bank Ltd",
      id: 2
    },
    {
      value: "ICICI Bank",
      id: 3
    },
  ]
   const ProofTypes = [
    {
      value: "Driving License",
      key: "DL",
      id: 1
    },
    {
      value: "Voter Card",
      key: "Voter",
      id: 2
    },
    {
      value: "Passport",
      key: "Passport",
      id: 3
    },
  ]
   const CLOSE_TAG_REASONS = [
    {
      key: "I have already sold my vehicle",
      text: "I have already sold my vehicle",
      val: 1
    },
    {
      key: "I am unhappy with the service",
      text: "I am unhappy with the service",
      val: 2
    },
    {
      key: "Others",
      text: "Others",
      val: 5
    },

  ];
   const AADHAR_MOBILE_CONFIRMATION = [
    {
      key: "Yes",
      text: "Yes",
      val: 1
    },
    {
      key: "No",
      text: "NO",
      val: 2
    },
  ];
   const amountPattern = /^[1-9][0-9]*\.{0,1}[0-9]{0,2}$/;

   const bankAcntPattern = /^[1-9][0-9]*\.{0,1}[0-9]{0,2}$/;
   const ifscPattern =/^[A-Z]{4}[0][0-9]{6}$/;

export default {
    gender, 
    maritalStatus,
    employmentType,
    monthsArray,
    titleList,
    ifscPattern,bankAcntPattern,amountPattern,AADHAR_MOBILE_CONFIRMATION,CLOSE_TAG_REASONS,ProofTypes,BankNamesData,AccountTypeData     
}